export default "__VITE_ASSET__B2LCuz9Q__"